import { useEffect, useRef } from 'react';
import type { CompanySubscriptionResponse, PlanSummary } from '../types';
import { PlanStartPanel } from './PlanStartPanel';

/** A modal around `PlanStartPanel`: focus moves into it, Escape closes it, and focus returns to what opened it. */
export function PlanChoiceDialog({
  plan, subscription, providerAvailable, onClose,
}: {
  plan: PlanSummary;
  subscription: CompanySubscriptionResponse | null;
  providerAvailable: boolean;
  onClose: () => void;
}) {
  const dialogRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    dialogRef.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('keydown', onKey);
      opener?.focus();
    };
  }, [onClose]);

  return (
    <div className="plan-dialog-backdrop">
      <div
        ref={dialogRef}
        className="card plan-dialog"
        role="dialog"
        aria-modal="true"
        aria-label={`Choose ${plan.name}`}
        tabIndex={-1}
      >
        <PlanStartPanel plan={plan} subscription={subscription} providerAvailable={providerAvailable} onCancel={onClose} />
      </div>
    </div>
  );
}
